module.exports = __webpack_public_path__ + "img/service_top.13c69960.png";